import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef
} from '@angular/core';
import { Logger, GlobalInfoService, AuthenticationService } from '@app/core';
import { SessionStorage } from 'ngx-webstorage';
import { TypeProcess, GlobalInfo, Etapas, Const, ConfirmComponent, Static } from '@app/shared';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { environment } from '@env/environment';
import { NotifierService } from '../services/notifier.service';
import { Annulation } from '../models/anulacion.model';
import { TitlePreviewDataSercice } from './shared/title-preview.data.service';

const log = new Logger('TitlePreviewComponent');

export interface FlowTitle {
  id: number;
  name: string;
  expediente?: string;
  estado_expediente?: string;
  idExpediente?: number;
  state: string;
  classState: any;
  lengthFlowsHistory: number;
  notSynchronized: boolean;
  microProcess: boolean;
  solicitud_radicado?: string;
  idTramite?:number;
  liquidation?: boolean;
  idLiquidation?: number;
}

@Component({
  selector: 'iw-title-preview',
  templateUrl: './title-preview.component.html',
  styleUrls: ['./title-preview.component.scss'],
  providers: [TitlePreviewDataSercice],
  encapsulation: ViewEncapsulation.None
})
export class TitlePreviewComponent implements OnInit {

  btnDocumentos:any = {"label":"Documentos del expediente",
                          "title_form":"Documentos del expediente"};
  btnSeguimiento:any = {"label":"Seguimiento",
                          "title_form":"Seguimientos del expediente"};
  // Contiene el tipo de proceso que se esta renderizando
  @Input() typeProcess: TypeProcess;
  // Entrada del id de la secundaria
  @Input()
  set secondary(id: number) {
    this._idSecondary = id;
    this.defineIsSecondary();
  }
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  @SessionStorage() isDesignTaskPreview: string;
  // Infortmación básica del flujo
  @Input() data: FlowTitle;
  @Input() show = true;
  // Contiene los titulos configurador
  @Input() titles: any[] = [];
  // Contiene los titulos dinamicos
  @Input() dynamicTitles: any[] = [];
  // Define si el titulo se encuentra en la instancia
  @Input() instance = true;
  // Define si hay cambios pendientes
  @Input() changePending = false;
  // Define si la tarea está abierta para ocultar los botones de minimizar
  @Input() openForm: Boolean;
  // Contiene el radocado del expediente para mostrarlo en el modal de anulaciones
  @Input() radicado_expediente: string;
  // Define cuando es un titulo statico para reducir el tamaño de los textos
  @Input() static: Boolean = false;
  // Define cuando mostrar eltitulo principal
  @Input() viewTitle: Boolean = false;
  // Contiene las etapas del tramite ( etapa actual y general)
  @Input() stage: Etapas;
  // define si se muestra el botón de documentos del expediente
  @Input() buscador_documentos: boolean = false;
  // define si muestra el botón de anular trámite
  @Input() annul: boolean = false;
  // define si muestra el botón de eliminar trámite de liquidacion
  @Input() delete_liquidation: boolean = false;
  // define si el trámite es de liquidacion
  @Input() liquidation: boolean = false;
  // define si el tramite tienen titulos dinamicos para los botones
  @Input() set buttons_labels(buttons: any[]){
    let btnSegResult = buttons.find(item => item.boton == 'btn_seguimiento');
    if(btnSegResult){
      this.btnSeguimiento = {"label":btnSegResult.label,
      "title_form":btnSegResult.title_form};
    }
    let btnDocResult = buttons.find(item => item.boton == 'btn_documento');
    if(btnDocResult){
      this.btnDocumentos = {"label":btnDocResult.label,
      "title_form":btnDocResult.title_form};
    }
  };
  // Contiene los titulos dinamicos principales
  dynamicTitlesPrincipal: any[] = [];
  // Controla la visibilidad del significado iconografico
  showElementHelper = false;
  // Controla la visibilidad de titulos dinamicos
  showDynamicTitle = false;
  // Define si es una secundaria
  isSecondary = false;
  // Define cuando mostrar etapa del tramite
  showStageProcedure = false;
  // Contiene los titulos finales
  configTitles = {};
  // Define cuando mostrar el boton de observaciones
  @Input() observations = environment.observationsExpediente;
  // informacion global de la libreria GlobalInfoService(gis)
  private global: Partial<GlobalInfo>;
  // id de la secundaria seleccionada
  private _idSecondary: number;
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Define el mensaje a mostrar en la modal de anulación
  annulMessage: string;
  // contiene la información de la anulación
  @Input() annulation: Annulation = {};
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    annul: false,
    delete_liquidation: false,
  };
  // Referencia al modal de documentos del expediente
  @ViewChild('modalDocumentsRecords') modalDocumentsRecords: TemplateRef<any>;
  // Referencia del modal de observaciones
  @ViewChild('modalObservations') modalObservations: TemplateRef<any>;
  // Referencia a la modald e anulación
  @ViewChild('modalAnnul') modalAnnulation: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirmFinish') private confirmFinish: ConfirmComponent;
  // Emite el evento de refrescar el flujo
  @Output() refreshFlow: EventEmitter<boolean> = new EventEmitter();
  // Click en info
  @Output() showHelper: EventEmitter<boolean> = new EventEmitter();
  // Emite el evento para limpiar el flujo despues de eliminar el tramite
  @Output() cleanFlow: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private ns: NotifierService,
    private gis: GlobalInfoService,
    private modalService: BsModalService,
    private as: AuthenticationService,
    private tds: TitlePreviewDataSercice
  ) {}

  ngOnInit() {
    let tempTitle = Static.copyObjet(this.titles);
    this.titles.length = 0;
    if(this.dynamicTitles && this.dynamicTitles.length){
      this.dynamicTitlesPrincipal = [];
      this.configTitles = {};
      this.dynamicTitles.forEach(tl => {
        if(!tl.tarea){
          this.dynamicTitlesPrincipal.push(tl);
        }
      });
      this.showDynamicTitle = true;
    }else{
      if (tempTitle.length) {
        this.configTitles = {};
        tempTitle.forEach((title: any) => {
          if (Object.keys(title).length) {
            Object.keys(title).forEach(key => {
              this.configTitles[key] = title[key];
            });
          }
        });
      }
    }
    if (!this.isDesignTaskPreview) {
      this.isDesignTaskPreview = 'compact';
    }
    this.gis.get().subscribe(global => {
      this.defineIsSecondary(global);
    });
    this.activateAction.annul = this.as.confirmPermission(
      Const.types_permissions.instanceProcess,
      Const.types_action_permissions.annul,
    );
    this.activateAction.delete_liquidation = this.as.confirmPermission(
      Const.types_permissions.instanceProcess,
      Const.types_action_permissions.deleteLiquidation,
    );
    log.debug(this.activateAction.delete_liquidation);
  }

  /**
   * Funcion qe emite el refrescar flujo
   *
   * @memberof TitlePreviewComponent
   */
  refresh() {
    this.refreshFlow.emit(true);
  }

  /**
   * Guarda en el localstorage el tipo de diseño seleccionado
   * notifica al componente padre para realizar el cambio de diseño
   *
   * @param {string} design
   * @memberof TitlePreviewComponent
   */
  defineDesign(design: string) {
    this.isDesignTaskPreview = design;
    this.ns.set({
      source: 'title-preview',
      eventTriggered: 'change',
      action: 'changeDesign'
    });
  }

  /**
   * Valida si el tramite actual es una secundaria
   *
   * @param {Partial<GlobalInfo>} setGlobal
   * @memberof TitlePreviewComponent
   */
  defineIsSecondary(setGlobal?: Partial<GlobalInfo>) {
    if (setGlobal) {
      this.global = setGlobal;
    }
    if (this.global && this.global.flow) {
      log.debug('global', this.global, 'id_enviado', this._idSecondary);
      if (this.global.flow.id === this._idSecondary) {
        this.isSecondary = true;
      } else {
        this.isSecondary = false;
      }
    }
  }

  /**
   * Abre el formulario de documentos del expediente
   *
   * @memberof TitlePreviewComponent
   */
  openDocumentsRecords() {
    this.modalRef = this.modalService.show(
      this.modalDocumentsRecords,
      Object.assign({}, { class: 'modal-lg-personalized', ignoreBackdropClick: true })
    );
  }

  /**
   * Abre el formulario de observaciones
   *
   * @memberof TitlePreviewComponent
   */
  openObservations() {
    this.modalRef = this.modalService.show(
      this.modalObservations,
      Object.assign({}, { class: 'modal-lg-personalized', ignoreBackdropClick: true })
    );
  }

  /**
   *Abre la modal de anulación
   *
   * @memberof TitlePreviewComponent
   */
  openAnnulation(data: string){
    this.annulMessage = data;
    this.modalRef = this.modalService.show(
      this.modalAnnulation,
      Object.assign({}, { class: 'modal-lg-personalized', ignoreBackdropClick: true })
    );
  }

  deleteProcess(){
    this.confirmFinish.open();
  }

  actionComfirm(res: boolean) {
    if (res) {
     this.tds.deleteProcess(this.data.idTramite).then(() => {
      this.cleanFlow.emit(true);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/title-preview/title-preview.component.ts